export class TwoFaLoginDto {
    token: string;

    constructor(private _token: string) {
        this.token = _token;
    }
}
